import { Box } from 'grommet'
import styled, { css } from 'styled-components'

import { NormalizedContainer } from '@theme'

const MAX_SIZE_MOBILE_LEFT_CONTAINER = 371
const MAX_SIZE_RIGHT_CONTAINER = 575
const MAX_HEIGHT_MOBILE_CONTAINER = 768
const MAX_WIDTH_IMAGE = 298
const HEIGHT_IMAGE = 373
const MIN_HEIGHT_WRAPPER = 404
const WIDTH_LAYOUT = 995

export const Wrapper = styled(Box)`
  align-items: center;
  background: ${({ theme }) => theme.newColors.gradientGrayRight};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  min-height: ${MIN_HEIGHT_WRAPPER}px;
  overflow: hidden;
  position: relative;
  width: 100%;

  ${({ theme }) => theme.below.tablet`
    flex-direction: column;
    max-height: unset;
  `}

  ${({ theme }) => theme.below.mobileXL`
    max-height: ${MAX_HEIGHT_MOBILE_CONTAINER}px;
    background: ${theme.newColors.gradientGray};
  `}
`

export const Content = styled(NormalizedContainer)`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  max-width: ${WIDTH_LAYOUT}px;
  width: 100%;

  .consult-request-form {
    ${({ theme }) => theme.below.mobileXL`
      button {
        margin-bottom: ${theme.newSpaces.xs3}px;
      }
    `}
  }

  ${({ theme }) => theme.below.tablet`
    flex-direction: column;
  `}

  ${({ theme }) => theme.below.mobileXL`
    max-height: ${MAX_HEIGHT_MOBILE_CONTAINER}px;
  `}
`

export const LeftSideWrapper = styled(Box)`
  display: flex;
  height: ${MIN_HEIGHT_WRAPPER}px;
  justify-content: flex-end;
  width: 100%;

  ${({ theme, widthImage }) => css`
    max-width: ${widthImage || MAX_WIDTH_IMAGE}px;
  `}

  ${({ theme }) => theme.below.laptop`
    display: flex;
    background: none;
    padding: 0;
    margin-top: ${theme.newSpaces.xs2}px;
  `}

  ${({ theme }) => theme.below.mobileL`
    height: ${MAX_SIZE_MOBILE_LEFT_CONTAINER}px;
  `}

  ${({ theme, marginTopMobile }) => theme.below.mobileXL`
    margin-top: ${marginTopMobile || 28}px;
  `}
`

export const RightSideWrapper = styled(Box)`
  align-items: center;
  display: flex;
  flex: 3;
  height: 100%;
  justify-content: center;
  max-width: ${MAX_SIZE_RIGHT_CONTAINER}px;
  padding: 0;
  width: 100%;

  .form-subtitle {
    max-width: ${MAX_SIZE_RIGHT_CONTAINER}px;
  }

  span {
    ${({ theme }) => theme.below.mobileXL`
      padding-left: ${theme.newSpaces.xs2}px;
    `}
  }

  ${({ theme }) => theme.below.laptop`
    padding: ${theme.newSpaces.xs2}px 0 12px;
    flex: 2;
  `}

  ${({ theme }) => theme.below.tablet`
    align-items: center;
    justify-content: center;
    margin: 0px;
    width: 100%;
  `}

  ${({ theme }) => theme.below.mobileXL`
    padding: 10px 0 12px;
  `}
`

export const ImageWrapper = styled(Box)`
  display: flex;
  height: 100%;

  ${({ theme, heightImage }) => css`
    height: ${heightImage || HEIGHT_IMAGE}px;
  `}

  position: relative;
  width: 100%;

  img {
    object-fit: cover;
  }

  ${({ theme }) => theme.below.tablet`
    width: 100%;
    height: 400px;
    margin: 0 auto;
    padding: 0;
  `}
`

export const DecorativeWrapper = styled(Box)`
  bottom: ${({ bottom }) => bottom && bottom}px;
  left: ${({ left }) => left && left}px;
  position: absolute;
  right: ${({ right }) => right && right}px;
  top: ${({ top }) => top && top}px;

  img {
    object-fit: contain;
  }

  ${({ theme }) => theme.below.laptop`
    display: none;
  `}
`
